import React, { useMemo } from 'react';
import JsonBuilderForm from '../JsonBuilderForm.lazy.jsx';
import { chartStyleSchema } from '../schemas.js';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';

const DEFAULT_THEME = { baseTheme: 'ag-default', palette: {}, params: {}, overrides: {} };
const DEFAULT_GRID_CONFIG = { datagrid_id: null, datagrid_preset_id: null };
const DEFAULT_GRID_DATA = {
  columns: [
    { field: 'month', headerName: 'Month' },
    { field: 'sales', headerName: 'Sales' },
    { field: 'expenses', headerName: 'Expenses' },
    { field: 'profit', headerName: 'Profit' }
  ],
  rows: [
    { month: 'January', sales: 10000, expenses: 4000, profit: 6000 },
    { month: 'February', sales: 12000, expenses: 5000, profit: 7000 },
    { month: 'March', sales: 8000, expenses: 3000, profit: 5000 },
    { month: 'April', sales: 15000, expenses: 7000, profit: 8000 }
  ]
};

function GridChartWidgetSettings({ widgetId }) {
  const setAttribute = useSetWidgetAttribute(widgetId);
  const widgetConfig = useSelector(state => state.dashboard.widgets[widgetId].data_config);
  const dataStore = useSelector(state => state.dashboard.widgets[widgetId].data_store);

  const fields = [
    {
      name: 'data_config.theme',
      label: I18n.t('grid_chart_theme'),
      initialValue: widgetConfig.theme,
      defaultValue: DEFAULT_THEME,
      infoTitle: I18n.t('grid_chart_theme_json_editor_title'),
      infoContent: (
        <div className="mb-1" dangerouslySetInnerHTML={{
          __html: I18n.t('grid_chart_theme_json_editor_info', {
            request_url: 'https://www.ag-grid.com/charts/themes-api/'
          })
        }} />
      ),
      schema: chartStyleSchema
    },
    {
      name: 'data_config.datagrid',
      label: I18n.t('grid_chart_config'),
      initialValue: widgetConfig.datagrid,
      defaultValue: DEFAULT_GRID_CONFIG,
      infoTitle: I18n.t('grid_chart_config_info_title'),
      infoContent: I18n.t('grid_chart_config_info_content')
    },
    {
      name: 'data_store',
      label: I18n.t('grid_chart_data'),
      initialValue: dataStore,
      defaultValue: DEFAULT_GRID_DATA,
      infoTitle: I18n.t('grid_chart_data_info_title'),
      infoContent: I18n.t('grid_chart_data_info_content')
    }
  ];

  const values = useMemo(() =>
    fields.reduce((acc, field) => {
      acc[field.name] = JSON.stringify(field.initialValue || {}, null, 2);
      return acc;
    }, {}), [fields]);

  return (
    <JsonBuilderForm
        fields={fields}
        setValues={(path, value) => setAttribute(path, value)}
        values={values}
      />
  );
};
export default GridChartWidgetSettings;